export default {
    // Header Section
    "discover_your": "खोजें अपना",
    "career_path": "करियर पथ",
    "professional_destiny_analysis": "पेशेवर भाग्य विश्लेषण",
    "career_report_description": "वैदिक ज्योतिष के आधार पर व्यापक करियर विश्लेषण के साथ अपने पेशेवर क्षमता को अनलॉक करें। आदर्श करियर पथ, व्यवसाय के अवसर, करियर परिवर्तन का समय और पेशेवर सफलता की रणनीतियों के बारे में जानकारी प्राप्त करें।",

    // Service Information
    "enter_details_for_career_analysis": "करियर विश्लेषण के लिए अपनी जानकारी दर्ज करें",
    "complete_career_analysis": "पूर्ण करियर विश्लेषण",
    "service_price": "सेवा मूल्य",
    "comprehensive_career_analysis_note": "आपकी पेशेवर क्षमता और करियर रोडमैप का गहन विश्लेषण",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_career_influence": "आपका नाम आपके पेशेवर प्रतिष्ठा और सफलता के पैटर्न को प्रभावित करता है",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फ़ोन नंबर",
    "enter_phone_number": "अपना फ़ोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "महिला",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_career_path": "आपके करियर से संबंधित ग्रह स्थिति निर्धारित करने के लिए आवश्यक",
    "time_of_birth": "जन्म समय",
    "exact_time_critical_for_career": "सटीक समय करियर हाउस की सही गणना के लिए जरूरी है",
    "place_of_birth": "जन्म स्थान",
    "place_of_birth_placeholder": "शहर, राज्य, देश",
    "location_essential_for_career": "स्थान करियर को प्रभावित करने वाली ग्रह स्थितियों को प्रभावित करता है",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेजी",
    "hindi": "हिंदी",
    "telugu": "तेलुगु",
    "kannada": "कन्नड़",
    "language_note": "आपका करियर विश्लेषण चुनी गई भाषा में प्रदान किया जाएगा",

    // Core Career Features
    "ideal_career_paths": "आदर्श करियर पथ",
    "professional_strengths_analysis": "पेशेवर ताकत का विश्लेषण",
    "business_prospects_guidance": "व्यवसायिक संभावनाओं के लिए मार्गदर्शन",
    "career_timing_predictions": "करियर समय भविष्यवाणियां",
    "skill_development_recommendations": "कौशल विकास की सिफारिशें",
    "pdf_download": "व्यापक पीडीएफ रिपोर्ट",

    "what_you_get": "आपके करियर विश्लेषण में क्या शामिल है",
    "detailed_career_roadmap": "विस्तृत करियर रोडमैप",
    "professional_strengths_weaknesses": "पेशेवर ताकत और कमजोरियां",
    "business_entrepreneurship_guidance": "व्यवसाय और उद्यमिता मार्गदर्शन",
    "career_transition_timing": "करियर परिवर्तन का समय",

    // Actions & Buttons
    "pay_and_generate_analysis": "मेरा करियर विश्लेषण प्राप्त करें",
    "processing_payment": "भुगतान प्रक्रिया जारी है",
    "processing_request": "विश्लेषण तैयार किया जा रहा है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "career_analysis_processing": "आपका करियर विश्लेषण हमारे विशेषज्ञ वैदिक ज्योतिषियों द्वारा तैयार किया जा रहा है। आपको अपने पेशेवर क्षमता और आदर्श करियर पथ पर विस्तृत जानकारी प्राप्त होगी।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "विश्लेषण डिलीवरी",
    "within_12_hours_delivery_note": "आपकी विस्तृत करियर रिपोर्ट 12 घंटे के भीतर तैयार होगी",
    "whatsapp_notification": "व्हाट्सएप अपडेट्स",
    "whatsapp_delivery_note": "व्हाट्सएप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूर्ण विश्लेषण भेजा जाएगा",

    // What You'll Receive
    "what_youll_receive": "आपका करियर विश्लेषण पैकेज",
    "detailed_career_report": "व्यापक करियर रिपोर्ट (PDF)",
    "suitable_career_options": "उपयुक्त करियर विकल्प और क्षेत्र",
    "professional_development_plan": "पेशेवर विकास योजना",
    "success_timing_analysis": "सफलता का समय विश्लेषण",
    "entrepreneurship_assessment": "उद्यमिता मूल्यांकन",

    // Visual Content
    "sample_career_analysis": "नमूना करियर विश्लेषण",
    "ideal_career_field": "आदर्श करियर क्षेत्र",
    "sample_career_description": "प्रौद्योगिकी और नवाचार - मजबूत विश्लेषणात्मक और नेतृत्व क्षमताएं",
    "sample_career_preview": "आपके व्यक्तिगत करियर विश्लेषण का पूर्वावलोकन, क्षेत्र सिफारिशों के साथ",
    "career_fields": "करियर क्षेत्र",

    // Career Field Types
    "technology": "प्रौद्योगिकी",
    "healthcare": "स्वास्थ्य सेवा",
    "finance": "वित्त",
    "creative_arts": "रचनात्मक कला",
    "education": "शिक्षा",
    "business": "व्यवसाय",

    // Status & Processing
    "your_career_analysis_status": "आपके करियर विश्लेषण की स्थिति",
    "processing_your_analysis": "आपकी करियर क्षमता का विश्लेषण किया जा रहा है",
    "analysis_processing_message": "हमारे वैदिक ज्योतिषी आपकी ग्रह स्थितियों का अध्ययन कर रहे हैं ताकि आदर्श करियर पथ और पेशेवर समय का निर्धारण किया जा सके।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति पर",
    "pending": "लंबित",
    "email_notification_sent": "पुष्टिकरण ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सएप अपडेट सक्षम",
    "delivery_within_12_hours": "रिपोर्ट 12 घंटे में तैयार",

    // Support & Contact
    "contact_support": "करियर सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक विवरण भरें",
    "payment_failed": "भुगतान असफल रहा। कृपया पुनः प्रयास करें।",
    "processing_failed": "विश्लेषण प्रक्रिया विफल रही। कृपया हमारी सहायता टीम से संपर्क करें।",

    // Career-Specific Elements
    "tenth_house": "10वां भाव (करियर भाव)",
    "ascendant_lord": "लग्नेश",
    "career_planets": "करियर को प्रभावित करने वाले ग्रह",
    "professional_dasha": "पेशेवर दशा काल",
    "career_yogas": "करियर योग",
    "success_indicators": "सफलता संकेतक",

    // Career Analysis Sections
    "natural_talents": "प्राकृतिक प्रतिभा और क्षमताएं",
    "professional_personality": "पेशेवर व्यक्तित्व",
    "leadership_qualities": "नेतृत्व गुण",
    "work_preferences": "कार्य वातावरण पसंद",
    "career_motivations": "करियर प्रेरणाएं",
    "professional_challenges": "पेशेवर चुनौतियां",

    // Suitable Career Paths
    "recommended_careers": "अनुशंसित करियर पथ",
    "alternative_careers": "वैकल्पिक करियर विकल्प",
    "avoid_careers": "जिन करियर से बचें",
    "freelancing_potential": "फ्रीलांसिंग क्षमता",
    "government_vs_private": "सरकारी बनाम निजी क्षेत्र",
    "international_opportunities": "अंतर्राष्ट्रीय करियर अवसर",

    // Business & Entrepreneurship
    "business_acumen": "व्यावसायिक समझ",
    "entrepreneurial_skills": "उद्यमशील कौशल",
    "partnership_compatibility": "व्यवसायिक साझेदारी संगतता",
    "investment_timing": "निवेश का समय",
    "business_sectors": "उपयुक्त व्यवसायिक क्षेत्र",
    "startup_potential": "स्टार्टअप सफलता क्षमता",

    // Professional Development
    "skill_enhancement": "कौशल संवर्धन क्षेत्र",
    "educational_recommendations": "शैक्षिक सिफारिशें",
    "certification_suggestions": "प्रमाणन सुझाव",
    "mentorship_guidance": "मार्गदर्शन और मेंटरशिप",
    "networking_strategies": "नेटवर्किंग रणनीतियां",
    "personal_branding": "पर्सनल ब्रांडिंग टिप्स",

    // Career Timing
    "career_growth_periods": "करियर वृद्धि काल",
    "job_change_timing": "नौकरी बदलने का सही समय",
    "promotion_periods": "पदोन्नति के अनुकूल समय",
    "salary_negotiation_timing": "वेतन वार्ता का समय",
    "business_launch_timing": "व्यवसाय शुरू करने का समय",
    "retirement_planning": "सेवानिवृत्ति योजना मार्गदर्शन",

    // Success Strategies
    "professional_networking": "पेशेवर नेटवर्किंग",
    "workplace_relationships": "कार्यस्थल संबंध",
    "conflict_resolution": "संघर्ष समाधान कौशल",
    "stress_management": "पेशेवर तनाव प्रबंधन",
    "work_life_balance": "कार्य-जीवन संतुलन",
    "career_setback_recovery": "करियर असफलता से उबरना",

    // Financial Aspects
    "earning_potential": "कमाई की क्षमता",
    "wealth_accumulation": "धन संचय पैटर्न",
    "financial_planning": "वित्तीय योजना सलाह",
    "investment_guidance": "निवेश मार्गदर्शन",
    "passive_income_opportunities": "निष्क्रिय आय के अवसर",
    "financial_security_timing": "वित्तीय सुरक्षा समयरेखा",

    // Industry-Specific Guidance
    "it_software": "आईटी और सॉफ्टवेयर",
    "banking_finance": "बैंकिंग और वित्त",
    "healthcare_medical": "स्वास्थ्य सेवा और चिकित्सा",
    "education_training": "शिक्षा और प्रशिक्षण",
    "media_entertainment": "मीडिया और मनोरंजन",
    "manufacturing_engineering": "निर्माण और इंजीनियरिंग",
    "sales_marketing": "बिक्री और विपणन",
    "consulting_services": "परामर्श और सेवाएं",

    // Professional Relationships
    "boss_relationships": "वरिष्ठ अधिकारियों के साथ संबंध",
    "colleague_dynamics": "सहकर्मी संबंध",
    "team_leadership": "टीम नेतृत्व शैली",
    "client_relationships": "ग्राहक संबंध प्रबंधन",
    "vendor_partnerships": "विक्रेता और साझेदारी प्रबंधन",

    // Career Remedies
    "career_remedies": "करियर संवर्धन उपाय",
    "professional_gemstones": "पेशेवर रत्न",
    "career_mantras": "करियर सफलता मंत्र",
    "workplace_vastu": "कार्यस्थल वास्तु टिप्स",
    "professional_colors": "पेशेवर भाग्यशाली रंग",
    "career_fasting": "करियर लाभकारी उपवास"
};
